import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import { OAuth } from '@betwixt/common/utils/auth.js';

import '../scss/navsAside.scss';

import PropTypes from 'prop-types';

class NavsAside extends Component {
  getSecondaryRoutes() {
    if (this.props.routes.secondary) return this.props.routes.secondary;
    //return this.props.routes.secondary.filter( (m) => m.component.id !== 'settings')
  }

  render() {
    const {
      User,
      routes,
      pagename,
      back,
      isVisible,
      renderItemMenu,
      client,
      history,
      style,
      i18n,
      getIcon,
      ManageAsideView,
      moduleConfig,
      NavsAsideExtendedComponent,
      NavsAsideSecondaryComponent,
      //gConfig,
    } = this.props;

    // TO DO console.log( _.find(this.state.routes.primary, { 'routes': {'path': } }) )

    const secondaryRoutes = this.getSecondaryRoutes(routes.secondary);
    const PrimaryModule = pagename
      ? require(`@betwixt/common/modules/${pagename}/module.json`)
      : false;
    const ModuleProfileIsEnabled =
      User && User.modulesActived
        ? User.modulesActived.find((m) => m.moduleId === 'profile')
        : false;
    const asideLabelKey = moduleConfig?.routes?.my?.asideLabelKey;
    const moduleNamespace = moduleConfig?.module?.id;
    const moduleAsideLabel =
      asideLabelKey && moduleNamespace
        ? i18n.getResource(i18n.language, moduleNamespace, asideLabelKey)
        : null;
    const primaryModuleLabel =
      moduleAsideLabel ||
      i18n.getResource(i18n.language, 'nav', `primaryMenu.${PrimaryModule.module.id}`);

    /*
        let sticky = activatingSticky(parentInfo, 22);
        let style = {
            'top': `${sticky.scrollTop}px`
        }
        */

    return (
      //<aside id="sidebar" className={`${(isVisible) ? 'isVisible' : ''} ${sticky.class}`}  style={style}>
      <aside id="sidebar" className={`${isVisible ? 'isVisible' : ''}`} style={style}>
        <div className={`containerSidebar ${isVisible ? 'isVisible' : ''}`}>
          <header>
            <div id="controllerAside">
              <ul>
                <li id="toggleAside" className={`${isVisible ? 'opened' : 'closed'}`}>
                  <button
                    type="button"
                    aria-label={isVisible ? 'Close aside' : 'Open aside'}
                    onClick={() => ManageAsideView(!isVisible)}
                  >
                    <div /> <div /> <div />
                  </button>
                </li>
              </ul>
            </div>
            {User ? (
              <section id="profile">
                <div className="imageProfile">
                  {' '}
                  <FontAwesomeIcon icon={faUser} />{' '}
                </div>
                <div className="content">
                  <div className="name_profile"> {User.username} </div>
                  <div className="companyname_profile"> {User.companyname} </div>
                  {ModuleProfileIsEnabled && (
                    <button
                      className="edit_profile"
                      type="button"
                      onClick={() => ManageAsideView(false)}
                    >
                      <NavLink to="/profile"> Edit Profile </NavLink>
                    </button>
                  )}
                </div>
                <div className="cta">
                  <button
                    type="button"
                    className="logout-btn"
                    onClick={() => OAuth.logout(client, history)}
                  >
                    Logout
                  </button>
                </div>
              </section>
            ) : (
              ''
            )}
          </header>

          <div id="container_menu">
            {secondaryRoutes.length ? (
              /* SECONDARY MENU */
              <nav>
                <ul>
                  <li>
                    <button
                      type="button"
                      className="btn_back"
                      onClick={() => back()}
                      aria-label="Back"
                    >
                      <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                  </li>
                  <li id="primaryModule" className={`ns-${PrimaryModule.module.id}`}>
                    <button
                      type="button"
                      onClick={() => ManageAsideView(isVisible)}
                      style={{ background: 'none', border: 'none', padding: 0, width: '100%' }}
                      aria-label="Open primary module"
                    >
                      <NavLink to={`/${PrimaryModule.routes.my.path}`}>
                        {getIcon(PrimaryModule)}
                        <span
                          dangerouslySetInnerHTML={{
                            __html: primaryModuleLabel,
                          }}
                        />
                      </NavLink>
                    </button>
                  </li>
                  {NavsAsideSecondaryComponent ? (
                    <NavsAsideSecondaryComponent
                      secondaryRoutes={secondaryRoutes}
                      pagename={pagename}
                      renderItemMenu={renderItemMenu}
                      ManageAsideView={ManageAsideView}
                      User={User}
                      i18n={i18n}
                      getIcon={getIcon}
                      isVisible={isVisible}
                    />
                  ) : (
                    renderItemMenu(secondaryRoutes, 'secondary', pagename)
                  )}
                </ul>
              </nav>
            ) : (
              /* PRIMARY MENU */
              <nav>
                {User === undefined ? (
                  <ul>
                    <li className="explore-btn">
                      {' '}
                      <NavLink to="/modules"> modules </NavLink>{' '}
                    </li>
                    <li className="btn-login">
                      {' '}
                      <NavLink to="/login"> login </NavLink>{' '}
                    </li>
                  </ul>
                ) : (
                  <ul>{renderItemMenu(routes.primary, 'primary')}</ul>
                )}
              </nav>
            )}
            {NavsAsideExtendedComponent && secondaryRoutes.length > 0 && (
              <NavsAsideExtendedComponent {...this.props} />
            )}
          </div>
        </div>

        {isVisible && (
          <button
            id="darkflow"
            type="button"
            aria-label="Close aside overlay"
            onClick={() => ManageAsideView(false)}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'transparent',
              border: 'none',
              zIndex: 1000,
            }}
          />
        )}
      </aside>
    );
  }
}

export default NavsAside;

NavsAside.propTypes = {
  User: PropTypes.shape({
    username: PropTypes.string,
    companyname: PropTypes.string,
    modulesActived: PropTypes.array,
  }),
  routes: PropTypes.shape({
    primary: PropTypes.array,
    secondary: PropTypes.array,
  }).isRequired,
  pagename: PropTypes.string,
  back: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  renderItemMenu: PropTypes.func.isRequired,
  client: PropTypes.object,
  history: PropTypes.object,
  style: PropTypes.object,
  i18n: PropTypes.shape({
    getResource: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
  getIcon: PropTypes.func,
  ManageAsideView: PropTypes.func.isRequired,
  NavsAsideExtendedComponent: PropTypes.elementType,
  NavsAsideSecondaryComponent: PropTypes.elementType,
  moduleConfig: PropTypes.shape({
    module: PropTypes.shape({
      id: PropTypes.string,
    }),
    routes: PropTypes.shape({
      my: PropTypes.shape({
        asideLabelKey: PropTypes.string,
      }),
    }),
  }),
  gConfig: PropTypes.object,
};
